module.exports = __webpack_public_path__ + "b64cd5cb65ee5e6b74e6ede787308e40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/works-with/logos/logo-polar.png
// module id = 1789
// module chunks = 1